import { api } from "../../lib/api";
export const getMethanolStatisticsData = async (statType, requestBody) => {
    const { data } = await api.post("/assets/statistics", requestBody, {
        params: { statType }
    });
    return data;
};
